import React from "react";
import { Star, Swords, ArrowRight, Flame } from "lucide-react";
import { UnlockList } from "./UnlockCard";
import { BossScorecard, BossRetry, StageUnlocked } from "./Boss";
import { CallCardNotice } from "@/components/calls/CallCardNotice";

export default function MissionSummary({ m, s, navigate }) {
  const unlocks = (s.new_unlocks || []).filter((u) => u.type !== "rank");
  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-2xl mx-auto space-y-4">
      <div className="tc-card p-8 text-center animate-fade-up">
        <div className="text-[11px] font-mono uppercase tracking-widest text-tc-muted">{m.is_boss ? (s.mastered ? "BOSS MARKET PASSED" : "BOSS MARKET — NOT PASSED YET") : "MISSION COMPLETE"}</div>
        <h1 className="font-heading text-2xl font-bold mt-1">{m.name}</h1>
        <div className="flex justify-center gap-2 mt-4" data-testid="mission-stars">
          {[1, 2, 3].map((i) => (
            <Star key={i} className={`w-9 h-9 transition-all ${i <= s.stars ? "text-tc-xp fill-tc-xp animate-fade-up" : "text-white/15"}`} style={{ animationDelay: `${i * 120}ms` }} />
          ))}
        </div>
        <div className="text-sm text-tc-sub mt-2" data-testid="lesson-outcome">Lesson: <span className="font-semibold text-tc-txt">{s.stars === 3 ? "Mastered" : s.stars === 2 ? "Strong" : "Completed"}</span></div>
        {s.xp_awarded > 0 && <div className="font-mono text-tc-xp text-lg mt-3" data-testid="mission-xp">+{s.xp_awarded} XP</div>}
      </div>

      <BossScorecard categories={s.categories} overall={s.overall} />
      <BossRetry practice={s.practice} />
      {s.stage_complete && <StageUnlocked copy={s.stage_unlocked_copy} />}
      <UnlockList unlocks={unlocks} />
      {s.call_card && <CallCardNotice result={{ call_card: s.call_card }} />}

      {s.skill_deltas?.length > 0 && (
        <div className="tc-card p-5">
          <div className="text-[11px] font-mono uppercase tracking-widest text-tc-muted">Skill Progress</div>
          <p className="text-[12px] text-tc-muted mt-0.5 mb-3">Cumulative progress toward full mastery, across all your training.</p>
          {s.skill_deltas.map((d) => (
            <div key={d.key} className="mb-2.5">
              <div className="flex justify-between text-[13px]"><span className="text-tc-sub">{d.label}</span><span className="font-mono text-tc-mastery" data-testid={`skill-progress-${d.key}`}>{(d.mastery * 100).toFixed(0)}% toward full mastery <span className="text-tc-bull">(+{d.delta}%)</span></span></div>
              <div className="h-1.5 rounded-full bg-white/10 mt-1 overflow-hidden"><div className="h-full bg-tc-mastery rounded-full" style={{ width: `${d.mastery * 100}%` }} /></div>
            </div>
          ))}
        </div>
      )}

      <div className="grid sm:grid-cols-2 gap-3">
        <div className="tc-card p-4"><div className="text-[10px] font-mono uppercase tracking-widest text-tc-bull">Best Decision</div><p className="text-sm text-tc-sub mt-1">{s.best_decision}</p></div>
        <div className="tc-card p-4"><div className="text-[10px] font-mono uppercase tracking-widest text-tc-pass">Work On</div><p className="text-sm text-tc-sub mt-1">{s.improvement?.description}</p></div>
      </div>

      {s.streak > 0 && <div className="text-center text-tc-pass text-sm font-mono flex items-center justify-center gap-1.5"><Flame className="w-4 h-4" /> {s.streak}-day training streak</div>}

      <div className="grid grid-cols-2 gap-3">
        <button onClick={() => navigate("/training")} className="rounded-lg bg-white/5 border border-white/10 py-3 text-sm hover:bg-white/10">Trader Path</button>
        {s.next_mission ? (
          <button data-testid="next-mission-btn" onClick={() => navigate(`/training/${s.next_mission.id}`)}
            className="rounded-lg bg-tc-coach text-tc-bg font-semibold py-3 text-sm hover:bg-tc-coach/90 flex items-center justify-center gap-1.5">
            {s.next_mission.is_boss ? <Swords className="w-4 h-4" /> : null} Next: {s.next_mission.name} <ArrowRight className="w-4 h-4" />
          </button>
        ) : (
          <button onClick={() => navigate("/dashboard")} className="rounded-lg bg-tc-coach text-tc-bg font-semibold py-3 text-sm hover:bg-tc-coach/90">Continue Next Time</button>
        )}
      </div>
    </div>
  );
}
